import { render, staticRenderFns } from "./relatedValues.vue?vue&type=template&id=774ceba8&scoped=true&"
import script from "./relatedValues.vue?vue&type=script&lang=js&"
export * from "./relatedValues.vue?vue&type=script&lang=js&"
import style0 from "./relatedValues.vue?vue&type=style&index=0&id=774ceba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ceba8",
  null
  
)

export default component.exports